(function(){
 function init(root){
  root.querySelectorAll('[data-five-l-family-page]').forEach(function(section){
   if(section.dataset.ready)return;section.dataset.ready='1';
   function measureHeader(){var header=document.querySelector('#shopify-section-five-l-photo-header');section.style.setProperty('--family-header-height',(header?header.getBoundingClientRect().height:0)+'px');}
   measureHeader();window.addEventListener('resize',measureHeader);
   var links=[].slice.call(section.querySelectorAll('.chapter-nav a'));
   if(links.length){
    var chapters=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)links.forEach(function(a){if(a.hash==='#'+e.target.id)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});});},{rootMargin:'-12% 0px -45% 0px',threshold:0});
    links.forEach(function(a){var el=section.querySelector(a.hash);if(el)chapters.observe(el);});
   }
   section.querySelectorAll('.video-control').forEach(function(button){
    var video=button.parentElement.querySelector('video');if(!video){button.hidden=true;return;}
    var reduce=matchMedia('(prefers-reduced-motion:reduce)'),manualPause=false;
    function update(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-label',button.textContent);}
    function respectMotion(){if(reduce.matches){video.removeAttribute('autoplay');video.pause();}}
    button.addEventListener('click',function(){manualPause=!video.paused;if(video.paused)video.play().catch(function(){});else video.pause();});
    video.addEventListener('play',update);video.addEventListener('pause',update);reduce.addEventListener('change',respectMotion);
    video.muted=true;respectMotion();update();
    new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting&&!reduce.matches&&!manualPause)video.play().catch(function(){});else video.pause();});},{threshold:.15}).observe(video);
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
